import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getData, postData, getLocalUrl } from './request'
import { addCases } from './utils'
import { asyncCheckDaemonCompatibility } from './daemonCompatibility'


function reqSensorsStatus() {
    return getData(getLocalUrl('status'))
}

function reqUsbDevices() {
    return getData(getLocalUrl('usb/devices'))
}

function reqSetUsbDevice(id, api) {
    return postData(getLocalUrl('usb/device'), { id })
        .then(json => {
            if (!json || json.result !== 0) {
                throw new Error((json && json.verbose) || 'Не удалось сменить USB устройство')
            }
            // Refresh status (device may have changed) and the device list.
            api.dispatch(asyncGetSensorsStatus())
            api.dispatch(asyncGetUsbDevices())
        })
}

export const asyncGetSensorsStatus = createAsyncThunk('asyncGetSensorsStatus', reqSensorsStatus)
export const asyncGetUsbDevices = createAsyncThunk('asyncGetUsbDevices', reqUsbDevices)
export const asyncSetUsbDevice = createAsyncThunk('asyncSetUsbDevice', reqSetUsbDevice)

const initialState = {
    reachable: null,
    usb: null,
    emu: null,
    state: null,
    errorName: null,
    checking: false,
    lastChecked: null,
    devices: [],
    configuredDevice: null,
    daemonApi: null,
    daemonApiCompatibility: null
}

function setChecking(state) {
    state.checking = true
}

function setStatus(state, { payload }) {
    state.checking = false

    const status = payload && payload.status

    if (!status) {
        state.reachable = true
        return
    }

    state.reachable = true
    state.usb = status.usb
    state.emu = status.emu
    state.state = status.state
    state.errorName = status.error
    state.lastChecked = Date.now()
}

function setUnreachable(state) {
    state.checking = false
    state.reachable = false
    state.usb = null
    state.emu = null
    state.state = null
    state.errorName = null
    state.lastChecked = Date.now()
}

function setUsbDevices(state, { payload }) {
    const devices = payload && payload.devices
    state.devices = Array.isArray(devices) ? devices : []
    state.configuredDevice = payload ? (payload.configured || null) : null
}

function clearUsbDevices(state) {
    state.devices = []
    state.configuredDevice = null
}

function setDaemonCompatibility(state, { payload }) {
    state.daemonApi = payload && payload.daemonApi != null ? payload.daemonApi : null
    state.daemonApiCompatibility = payload ? payload.daemonApiCompatibility : null
}

function clearDaemonCompatibility(state) {
    state.daemonApi = null
    state.daemonApiCompatibility = null
}

export const connectivitySlice = createSlice({
    name: 'connectivity',
    initialState,
    reducers: {},
    extraReducers: builder => {
        addCases(builder, asyncGetSensorsStatus, setStatus, setChecking, setUnreachable)
        addCases(builder, asyncGetUsbDevices, setUsbDevices, clearUsbDevices, clearUsbDevices)
        addCases(builder, asyncSetUsbDevice, undefined, undefined, undefined)
        addCases(builder, asyncCheckDaemonCompatibility, setDaemonCompatibility, clearDaemonCompatibility, clearDaemonCompatibility)
    }
})

export function getConnectivity(state) {
    return state && state.connectivity
}

export function isConnectivityReachable(state) {
    return state && state.connectivity && state.connectivity.reachable
}

export function isUsbConnected(state) {
    return state && state.connectivity && state.connectivity.reachable && state.connectivity.usb === true
}